console.log('test.js')
